"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var molecules_1 = require("../../molecules");
var Input = function (_a) {
    var _b;
    var inputFieldProps = _a.inputFieldProps, _c = _a.labelProps, labelProps = _c === void 0 ? {} : _c, _d = _a.supporterInfoProps, supporterInfoProps = _d === void 0 ? {} : _d, _e = _a.showLabel, showLabel = _e === void 0 ? false : _e, _f = _a.showSupporterInfo, showSupporterInfo = _f === void 0 ? false : _f, _g = _a.inputFieldWrapperClass, inputFieldWrapperClass = _g === void 0 ? 'tw-w-full tw-my-[12px]' : _g, _h = _a.wrapperClass, wrapperClass = _h === void 0 ? 'tw-w-full' : _h, id = _a.id;
    return (react_1.default.createElement("div", { className: wrapperClass, "data-testid": "input-wrapper-" + id },
        showLabel && react_1.default.createElement(molecules_1.Label, __assign({}, labelProps, { id: "input-label-" + ((_b = inputFieldProps === null || inputFieldProps === void 0 ? void 0 : inputFieldProps.inputTagProps) === null || _b === void 0 ? void 0 : _b.id) })),
        react_1.default.createElement("div", { className: inputFieldWrapperClass, "data-testid": "input-field-wrapper-" + id },
            react_1.default.createElement(molecules_1.InputField, __assign({}, inputFieldProps))),
        showSupporterInfo && react_1.default.createElement(molecules_1.SupporterInfo, __assign({}, supporterInfoProps, { id: id }))));
};
exports.default = react_1.memo(Input);
